type IdleDeadline = { didTimeout: boolean; timeRemaining: () => number };

export function runWhenIdle(callback: () => void, timeoutMs = 2000) {
  if (typeof window !== "undefined" && typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(() => callback(), { timeout: timeoutMs });
    return;
  }
  setTimeout(callback, 0);
}

export async function prefetchWhenIdle(fetchFn: () => Promise<void>, timeoutMs = 2000) {
  runWhenIdle(() => {
    fetchFn().catch((error) => {
      console.error("Idle prefetch failed:", error);
    });
  }, timeoutMs);
}
